import {
  AppRoutePaths,
  AppSearchParams,
  IncomeInsuranceRoutePaths,
} from 'app-constants';
import { PageUrlCheckRender } from 'components/page-url-check-render';
import { useRootContext } from 'context/root';
import type { PropsWithChildren } from 'react';
import { Navigate, useLocation, useSearchParams } from 'react-router-dom';

export const AuthInsuranceHashPageUrlCheckRender = ({
  children,
}: PropsWithChildren) => {
  const { pathname } = useLocation();
  const { user } = useRootContext();
  const [searchParams] = useSearchParams();
  const insuranceHash = searchParams.get(AppSearchParams.insuranceHash);

  const isLoggedIn = user?.id;

  if (!isLoggedIn && !pathname.includes(IncomeInsuranceRoutePaths.LOGIN)) {
    return (
      <Navigate
        to={`/${AppRoutePaths.INCOME_INSURANCE}/${IncomeInsuranceRoutePaths.LOGIN}`}
      />
    );
  }

  return (
    <PageUrlCheckRender skipCheck={!isLoggedIn && !insuranceHash}>
      {children}
    </PageUrlCheckRender>
  );
};
